import React, { Component } from "react";
import { default as ReactSelect } from "react-select";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { isDesktop } from "react-device-detect";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import NumberInput from "../../components/Input/NumberInput/NumberInput";
import StringInput from "../../components/Input/StringInput/StringInput";
import {
    postForgotPasswordEmail,
    generateForgotPasswordOTP,
    resendForgotPasswordOTP,
    verifyForgotPasswordOTP,
    postForgotPassword,
    checkForgotPassword,
    postForgotPasswordOTP,
} from "../../store/ducks/forgotPassword/actions";

import { generateSMSOTP, verifySMSOTP, resendOTP } from "../../store/ducks/profile/actions";
import { getCountry } from "../../store/ducks/home/actions";
import Button from "../../components/Button/Button";
import { Link } from "react-router-dom";
import { formValidation } from "../../hoc/Shared/utility";

let countryList = [];
let contact_no_min_limits = 9;
let contact_no_max_limits = 10;

export class ForgetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countryOption: "MY",
            countryPhone: "+60",
            changeTabs: "email_address",
            email: "",
            errorMsg: [],
            time: {},
            seconds: 180,
            timer: 0,
            currentMobileNo: "",
            currentMobileDialCode: "",
            otp_code: "",
            resetPasswordSubmit: false,
        };
    }
    componentDidMount() {
        if (this.props.match.params.token) {
            const data = {};
            data.token = this.props.match.params.token;

            this.props.checkForgotPassword(data);
        }

        this.props.getCountry();
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;
        if (nextProps.countryData !== this.props.countryData) {
            this.setState({
                referral: sessionStorage.getItem("referralCode"),
            });
            countryList = [];

            let countryData = nextProps.countryData.country;

            Object.keys(countryData).map((item, i) => {
                countryList.push({
                    // label: countryData[item].dialCode + "(" + countryData[item].countryName + ")",
                    name: countryData[item].countryName,
                    value: countryData[item].dialCode,
                    phone: countryData[item].dialCode,
                    code: countryData[item].countryShortCode,
                    image: countryData[item].countryShortCode + ".webp",
                });

                return [countryList];
            });

            this.setState({ loading: false });
        }

        if (nextProps.post_forgot_password_email_data !== this.props.post_forgot_password_email_data) {
            const { t } = this.props;
            if (nextProps.post_forgot_password_email_data.responseCode === 200) {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    title: t("global.success"),
                    text: t("forgot-password.success"),
                    // icon: nextProps.post_forgot_password_email_data.msgType,
                    icon: "success",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sucess",
                              icon: "swal-success-icon",
                          }
                        : [],
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({ showSendSuccessMessage: true });
                    }
                });
            } else if (nextProps.post_forgot_password_email_data.responseCode === 422) {
                this.setState({
                    loading: false,
                    touched: true,
                    errorMsg: nextProps.post_forgot_password_email_data.message.input_error || [],
                    formError: true,
                });
                Swal.close();
            } else {
                this.setState({ loading: false });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    title: t("global.sorry"),
                    text: t("forgot-password.error"),
                    // icon: nextProps.post_forgot_password_email_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                });
            }
        }

        if (nextProps.check_forgot_password_data !== this.props.check_forgot_password_data) {
            if (nextProps.check_forgot_password_data.responseCode === 200) {
                this.props.history.push("/change-password/" + this.props.match.params.token);
            } else {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    title: t("global.sorry"),
                    text: nextProps.check_forgot_password_data.data.message,
                    // icon: nextProps.check_forgot_password_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sucess",
                              icon: "swal-success-icon",
                          }
                        : [],
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.props.history.push("/");
                    }
                });
            }
        }

        if (nextProps.generate_forgot_password_otp_data !== this.props.generate_forgot_password_otp_data) {
            if (nextProps.generate_forgot_password_otp_data.responseCode === 200) {
                if (!nextProps.generate_forgot_password_otp_data.data.sms_reached_limit) {
                    let timeLeftVar = this.secondsToTime(this.state.seconds);

                    this.setState({ time: timeLeftVar });

                    this.startTimer();
                }

                this.setState({
                    generateOTPStatus: true,
                    check_sending_sms_times: nextProps.generate_forgot_password_otp_data.data.count_sending_sms_times,
                    check_sending_sms_status: nextProps.generate_forgot_password_otp_data.data.sms_reached_limit === true ? false : true,
                    resend_otp_button_disabled: true,
                });

                if (!nextProps.generate_forgot_password_otp_data.data.sms_reached_limit) {
                    Swal.fire({
                        iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                        // icon: nextProps.generate_forgot_password_otp_data.msgType,
                        icon: "success",
                        title: t("global.success"),
                        // text: "Successful request OTP",
                        html: t("profile.generate-sms-otp-success"),
                        showConfirmButton: true,
                        confirmButtonText: t("global.ok"),
                        customClass: !isDesktop
                            ? {
                                  container: "swal-mobile-container sucess",
                                  icon: "swal-success-icon",
                              }
                            : [],
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.close();
                        }
                    });
                }
            } else {
                this.setState({
                    touched: true,
                    errorMsg: nextProps.generate_forgot_password_otp_data.data.message.input_error || [],
                    formError: true,
                });

                // Swal.close();
            }
        }

        if (nextProps.verify_forgot_password_otp_data !== this.props.verify_forgot_password_otp_data) {
          if (nextProps.verify_forgot_password_otp_data.responseCode === 200) {
              Swal.fire({
                  iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : '',
                  // icon: nextProps.verify_forgot_password_otp_data.msgType,
                  icon: 'success',
                  title: t("global.success"),
                  html: t("forgot-password.forgot-password-pin"),
                  showConfirmButton: true,
                  confirmButtonText: t("global.ok"),
                  customClass: (!isDesktop) ? {
                      container: 'swal-mobile-container sucess',
                      icon: 'swal-success-icon'
                  } : [],
              }).then((result) => {
                  if (result.isConfirmed) {
                      Swal.close();
                  }
                  this.props.history.push("/change-password/" + this.state.countryPhone.substring(1) + this.state.currentMobileNo);
              });

              clearInterval(this.timer);
          } else {
              this.setState({
                  touched: true,
                  errorMsg: (nextProps.verify_forgot_password_otp_data.message.input_error || []),
                  formError: true
              });
              Swal.close();
          }
      }

      if (nextProps.resend_forgot_password_otp_data !== this.props.resend_forgot_password_otp_data) {
        if (nextProps.resend_forgot_password_otp_data.responseCode === 200) {
            if (!nextProps.resend_forgot_password_otp_data.data.sms_reached_limit) {
                this.setState({ check_sending_sms_status: false });
                Swal.close();
            } else {
            Swal.fire({
                iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : '',
                // icon: nextProps.resend_forgot_password_otp_data.msgType,
                icon: 'success',
                title: t("global.success"),
                //text: press second time request will get this message
                html: t("profile.generate-sms-otp-success"),
                showConfirmButton: true,
                confirmButtonText: t("global.ok"),
                customClass: (!isDesktop) ? {
                    container: 'swal-mobile-container sucess',
                    icon: 'swal-success-icon'
                } : [],
            }).then(() => {
                this.setState({
                    generateOTPStatus: true,
                    openMobileModal: true,
                    check_sending_sms_times: nextProps.resend_forgot_password_otp_data.data.count_sending_sms_times,
                    seconds: 180,
                    timer: 0,
                    resend_otp_button_disabled: true,
                });
            });
            }
        } else {
            this.setState({
                touched: true,
                errorMsg: nextProps.resend_forgot_password_otp_data.data.message.input_error || [],
                formError: true,
                resend_otp_button_disabled: true,
            });
            Swal.close();
        }
    }

        return true;
    }

    toggleChangeTabs = (name) => {
        this.setState(
            {
                changeTabs: name,
            },
            () => {
                if (name === "mobile_phone") {
                    formValidation("mobile_phone_forgot_password_form");
                }
            }
        );
    };

    toggleResetPassword = () => {
        this.setState({
            resetPasswordSubmit: !this.state.resetPasswordSubmit,
        });
    };

    imageImport = (r) => {
        let images = {};
        r.keys().map((item) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            h: hours,
            m: minutes,
            s: seconds.toString().padStart(2, "0"),
        };
        return obj;
    }

    startTimer() {
        if (this.state.timer === 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
            this.setState({ showTime: true });
        }
    }

    countDown = () => {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;

        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds === 0) {
            clearInterval(this.timer);
            this.setState({ resend_otp_button_disabled: false, disabled_resend_contact_no: false, showTime: false });
        }
    };

    submitForgotPasswordEmailHandler = (event) => {
        event.preventDefault();

        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            icon: "warning",
            text: t("global.would-you-like-to-proceed") + "?",
            confirmButtonText: t("global.confirm"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                      container: "swal-mobile-container confirmation",
                      icon: "swal-confirmation-icon",
                  }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading();
                    },
                });

                const data = {};
                data.email = this.state.email;
                data.language_code = this.props.lng;
                data.url = window.location.origin;
                this.props.postForgotPasswordEmail(data);
            }
        });
    };

    verifyOtpHandler = (event) => {
        event.preventDefault();
        const { t } = this.props;

        if (isDesktop) {
            Swal.fire({
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                icon: "warning",
                confirmButtonText: t("global.confirm"),
                showDenyButton: true,
                denyButtonText: t("global.cancel"),
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    const data = {};

                    // if (this.state.resend_contact_no !== "") {
                    // data.contact_no = this.state.currentMobileDialCode + this.state.resend_contact_no;
                    // } else {
                    data.contact_no = this.state.currentMobileDialCode + this.state.currentMobileNo;
                    // }

                    data.otp_code = this.state.mobileVarificationCode;

                    this.props.verifySMSOTP(data);
                }
            });
        } else {
            Swal.fire({
                iconHtml: '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">',
                icon: "warning",
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                confirmButtonText: t("global.confirm"),
                showCancelButton: true,
                cancelButtonText: t("global.cancel"),
                customClass: {
                    container: "swal-mobile-container confirmation",
                    icon: "swal-confirmation-icon",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    const data = {};

                    // if (this.state.resend_contact_no !== "") {
                    // data.contact_no = this.state.currentMobileDialCode + this.state.resend_contact_no;
                    // } else {
                    data.contact_no = this.state.currentMobileDialCode + this.state.currentMobileNo;
                    // }

                    data.otp_code = this.state.mobileVarificationCode;

                    this.props.verifySMSOTP(data);
                }
            });
        }
    };

    handleEmail = (event) => {
        this.setState({ email: event.target.value });
    };

    enterMobileVarificationCode = (e) => {
        this.setState({
            mobileVarificationCode: e.target.value,
        });
    };

    enterEmailVarificationCode = (e) => {
        this.setState({
            emailVarificationCode: e.target.value,
        });
    };

    generateOTPHandler = (event) => {
        event.preventDefault();
        const data = {};
        // if (this.state.resend_contact_no === "") {
        data.contact_number = this.state.countryPhone + this.state.currentMobileNo;
        data.contact_prefix = this.state.countryPhone;

        // } else {
        // data.contact_number = this.state.currentMobileDialCode + this.state.resend_contact_no;
        // }

        Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        this.props.generateForgotPasswordOTP(data);
    };

    resendOTPHandler = (event) => {
      event.preventDefault();

      const { t } = this.props;
      Swal.fire({
          iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : '',
          title: t("global.confirmation"),
          text: t("global.would-you-like-to-proceed") + "?",
          icon: "warning",
          confirmButtonText: t("global.confirm"),
          showDenyButton: true,
          denyButtonText: t("global.cancel"),
          customClass: (!isDesktop) ? {
              container: "swal-mobile-container confirmation",
              icon: "swal-confirmation-icon", 
          } : [],
      }).then((result) => {
          if (result.isConfirmed) {
              Swal.fire({
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  didOpen: () => {
                      Swal.showLoading();
                  },
              });

              const data = {};

              data.contact_number = this.state.countryPhone + this.state.currentMobileNo;

              data.contact_prefix = this.state.countryPhone;

              this.props.resendForgotPasswordOTP(data);

              this.setState({ seconds: 180 });

              let timeLeftVar = this.secondsToTime(this.state.seconds);

              this.setState({ time: timeLeftVar });

              this.startTimer();
          }
      });
  };

    selectCountry = (event) => {
        this.setState({
            countryOption: event.code,
            countryPhone: event.phone,
        });
    };

    currentMobileNoFunction = (e) => {
        this.setState({
            currentMobileNo: e.target.value,
        });
    };

    otp_code_Function = (e) => {
        this.setState({
            otp_code: e.target.value,
        });
    };

    verifyForgotPasswordOTPHandler = (event) => {
      event.preventDefault();

      const { t } = this.props;

      Swal.fire({
          iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : '',
          title: t("global.confirmation"),
          text: t("global.would-you-like-to-proceed") + "?",
          icon: "warning",
          confirmButtonText: t("global.confirm"),
          showDenyButton: true,
          denyButtonText: t("global.cancel"),
          customClass: (!isDesktop) ? {
              container: "swal-mobile-container confirmation",
              icon: "swal-confirmation-icon",
          } : [],
      }).then((result) => {
          if (result.isConfirmed) {
              Swal.fire({
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  didOpen: () => {
                      Swal.showLoading();
                  },
              });

              const data = {};

              // if (this.state.resend_contact_no !== "") {
              // data.contact_no = this.state.currentMobileDialCode + this.state.resend_contact_no;
              // } else {
              data.contact_number = this.state.countryPhone + this.state.currentMobileNo;
              // }

              data.otp_code = this.state.otp_code;

              this.props.verifyForgotPasswordOTP(data);
          }
      });
  }

    render() {
        const { t } = this.props;
        const icon = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
        const flags = this.imageImport(require.context("../../assets/images/flags/", false, /\.(png|jpe?g|svg|webp)$/));
        const logo = this.imageImport(require.context("../../assets/images/", false, /\.(png|jpe?g|svg|webp)$/));

        switch (this.state.countryOption) {
            case "MY":
                contact_no_min_limits = 9;
                contact_no_max_limits = 13;
                break;
            case "TH":
                contact_no_min_limits = 8;
                contact_no_max_limits = 8;
                break;
            case "ID":
                contact_no_min_limits = 10;
                contact_no_max_limits = 10;
                break;
            case "VN":
                contact_no_min_limits = 9;
                contact_no_max_limits = 9;
                break;
            case "7":
                contact_no_min_limits = 10;
                contact_no_max_limits = 10;
                break;
            default:
                break;
        }

        let resendOTPCountDownTimer;

        if (this.state.resend_otp_button_disabled === true) {
            resendOTPCountDownTimer = "0" + this.state.time.m + ":" + this.state.time.s;
        } else {
            resendOTPCountDownTimer = "";
        }

        return (
            <Auxiliary>
                {isDesktop ? (
                    <section className="logreg-wrap">
                        <div className="logreg-logo">
                            <img src={logo["x33-logo.png"]} alt="logo" />
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <img className="left-img" src={icon["img_affliate_bg_1.webp"]} alt="logo" />
                            </div>
                            <div className="col-6">
                                <div className="logreg-body-wrap">
                                    <h4>{t("change-password.forget-user-or-pass")}</h4>
                                    <p>{t("change-password.subtitle-forget")}</p>
                                    <div className="underline-nav-tabs p-0 mt-2">
                                        <ul className="nav nav-tabs">
                                            <li className="nav-item">
                                                <a
                                                    className={`nav-link ${this.state.changeTabs === "email_address" ? "active" : ""}`}
                                                    role="button"
                                                    onClick={() => this.toggleChangeTabs("email_address")}
                                                >
                                                    <p>{t("profile.email-address")}</p>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    className={`nav-link ${this.state.changeTabs === "mobile_phone" ? "active" : ""}`}
                                                    role="button"
                                                    onClick={() => this.toggleChangeTabs("mobile_phone")}
                                                >
                                                    <p>{t("change-password.mobile-phone")}</p>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    {this.state.changeTabs === "email_address" ? (
                                        <form
                                            className="forms-col needs-validation"
                                            method="post"
                                            name="email_address_form"
                                            id="forgot_password_form"
                                            onSubmit={this.submitForgotPasswordEmailHandler}
                                            noValidate
                                        >
                                            <div>
                                                <small>{t("change-password.enter-email")}</small>
                                                <div className="input-group w-l-border has-validation">
                                                    <StringInput
                                                        className={`${this.state.errorMsg.email && "was-validated is-invalid"}`}
                                                        onChange={this.handleEmail}
                                                        id="email"
                                                        name="email"
                                                        placeholder="examplex33@gmail.com"
                                                        value={this.state.email}
                                                        required
                                                        valid_email="true"
                                                        requiredMessage={t("validation.required")}
                                                        emailMessage={t("validation.email")}
                                                        errorMsg={this.state.errorMsg.email || ""}
                                                        formError={this.state.formError}
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </div>
                                            <button className="btn btn-gradient-blue rounded-pill" type="submit" disabled={this.state.email === "" ? true : false}>
                                                {t("global.submit")}
                                            </button>
                                            <button className="just-blue-btn mt-2 ">
                                                <Link to={{ pathname: "/login" }}>
                                                    {"<<"} {t("global.back")}
                                                </Link>
                                            </button>
                                        </form>
                                    ) : (
                                        this.state.changeTabs === "mobile_phone" && (
                                            <form
                                                id="mobile_phone_forgot_password_form"
                                                name="mobile_phone_forgot_password_form"
                                                className="forms-col needs-validation"
                                                noValidate
                                                onSubmit={this.verifyForgotPasswordOTPHandler}
                                            >
                                                <div>
                                                    <small>{t("change-password.enter-phone")}</small>
                                                    <div className="input-group left has-validation">
                                                        <ReactSelect
                                                            classNamePrefix="react-select"
                                                            defaultValue={countryList.filter((country) => country.code === "MY")}
                                                            options={countryList}
                                                            onChange={this.selectCountry}
                                                            formatOptionLabel={(item) => (
                                                                <>
                                                                    <img src={flags[`${item.image}`]} alt={item.image} />
                                                                    <p>{item.phone}</p>
                                                                </>
                                                            )}
                                                        />

                                                        <StringInput
                                                            className={`${this.state.errorMsg.contact_no && "was-validated is-invalid"}`}
                                                            // className="was-validated is-invalid"
                                                            type="text"
                                                            placeholder={t("profile.mobile-phone-no")}
                                                            name="verificationMobileNo"
                                                            defaultValue=""
                                                            autoComplete="off"
                                                            value={this.state.currentMobileNo}
                                                            onChange={this.currentMobileNoFunction}
                                                            minLength={this.state.contactNoMinLimits}
                                                            maxLength={this.state.contactNoMaxLimits}
                                                            minLengthMessage={t("validation.minLength", { 0: this.props.contactNoMinLimits })}
                                                            maxLengthMessage={t("validation.maxLength", { 0: this.props.contactNoMaxLimits })}
                                                            required
                                                            requiredMessage={t("validation.required")}
                                                            errorMsg={this.state.errorMsg.contact_no || ""}
                                                            // formError={this.props.formError}
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <small>{t("change-password.enter-code")}</small>
                                                    <div className="input-group w-l-border has-validation">
                                                        <NumberInput
                                                            className={`form-control forget-pwd-desktop ${this.state.errorMsg.otp_code && "was-validated is-invalid"}`}
                                                            type="number"
                                                            onChange={this.otp_code_Function}
                                                            // onChange={(e) => {
                                                            //   this.setState({
                                                            //     otp_code: e.target.value,
                                                            //   });
                                                            // }}
                                                            placeholder=""
                                                            errorMsg={this.state.errorMsg.otp_code || ""}
                                                            formError={this.state.formError}
                                                            required
                                                            requiredMessage={t("validation.required")}
                                                            value={this.state.otp_code}
                                                            format={
                                                                <span className="input-group-text right-btn-bg ">
                                                                    {this.state.generateOTPStatus && this.state.check_sending_sms_status ? (
                                                                        <button
                                                                            type="button"
                                                                            className={`btn right-btn breg-btn  ${this.state.showTime ? "disabled" : "active"}`}
                                                                            onClick={this.resendOTPHandler}
                                                                        >
                                                                            <span>{t("global.resend")}</span>
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            type="button"
                                                                            className={`btn right-btn breg-btn ${this.state.showTime ? "disabled" : "active"}`}
                                                                            onClick={this.generateOTPHandler}
                                                                        >
                                                                            <span>{t("change-password.request-otp")}</span>
                                                                        </button>
                                                                    )}
                                                                </span>
                                                            }
                                                        />
                                                    </div>
                                                    {this.state.showTime ? <span className="count">{resendOTPCountDownTimer}</span> : ""}
                                                </div>
                                                <button className="btn btn-gradient-blue rounded-pill" type="submit" disabled={this.state.otp_code === "" ? true : false}>
                                                    {t("global.submit")}
                                                </button>

                                                <button className="just-blue-btn mt-2 ">
                                                    <Link to={{ pathname: "/login" }}>
                                                        {"<<"} {t("global.back")}
                                                    </Link>
                                                </button>
                                            </form>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <section className="logreg-wrap">
                        <div className="logreg-logo">
                            <img src={logo["x33-logo.png"]} alt="logo" />
                        </div>
                        <div className="pt-4">
                            <img className="left-img" src={icon["img_affliate_bg_1.webp"]} alt="logo" />
                        </div>
                        <div className="logreg-content w-shadow">
                            <div className="logreg-body-wrap forget-pass text-start">
                                <h4>{t("change-password.forget-user-or-pass")}</h4>
                                <p>{t("change-password.subtitle-forget")}</p>
                                <div className="underline-nav-tabs p-0 mt-2">
                                    <ul className="nav nav-tabs">
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${this.state.changeTabs === "email_address" ? "active" : ""}`}
                                                role="button"
                                                onClick={() => this.toggleChangeTabs("email_address")}
                                            >
                                                <p>{t("profile.email-address")}</p>
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${this.state.changeTabs === "mobile_phone" ? "active" : ""}`}
                                                role="button"
                                                onClick={() => this.toggleChangeTabs("mobile_phone")}
                                            >
                                                <p>{t("change-password.mobile-phone")}</p>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                {this.state.changeTabs === "email_address" ? (
                                    <form
                                        className="forms-col needs-validation"
                                        method="post"
                                        name="email_address_form"
                                        id="forgot_password_form"
                                        onSubmit={this.submitForgotPasswordEmailHandler}
                                        noValidate
                                    >
                                        <div>
                                            <small>{t("change-password.enter-email")}</small>
                                            <div className="input-group w-l-border has-validation">
                                                <StringInput
                                                    className={`${this.state.errorMsg.email && "was-validated is-invalid"}`}
                                                    onChange={this.handleEmail}
                                                    id="email"
                                                    name="email"
                                                    placeholder="examplex33@gmail.com"
                                                    value={this.state.email}
                                                    required
                                                    valid_email="true"
                                                    requiredMessage={t("validation.required")}
                                                    emailMessage={t("validation.email")}
                                                    errorMsg={this.state.errorMsg.email || ""}
                                                    formError={this.state.formError}
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                        <button className="btn btn-gradient-blue rounded-pill" type="submit" disabled={this.state.email === "" ? true : false}>
                                            {t("global.submit")}
                                        </button>
                                        <button className="just-blue-btn mt-2 ">
                                            <Link to={{ pathname: "/login" }}>
                                                {"<<"} {t("global.back")}
                                            </Link>
                                        </button>
                                    </form>
                                ) : (
                                    this.state.changeTabs === "mobile_phone" && (
                                        <form className="forms-col needs-validation" noValidate onSubmit={this.verifyForgotPasswordOTPHandler}>
                                            <div>
                                                <small>{t("change-password.enter-phone")}</small>
                                                <div className="input-group left has-validation">
                                                    <ReactSelect
                                                        classNamePrefix="react-select"
                                                        defaultValue={countryList.filter((country) => country.code === "MY")}
                                                        options={countryList}
                                                        onChange={this.selectCountry}
                                                        formatOptionLabel={(item) => (
                                                            <>
                                                                <img src={flags[`${item.image}`]} alt={item.image} />
                                                                <p>{item.phone}</p>
                                                            </>
                                                        )}
                                                    />

                                                      <StringInput
                                                            className={`${this.state.errorMsg.contact_no && "was-validated is-invalid"}`}
                                                            // className="was-validated is-invalid"
                                                            type="text"
                                                            placeholder={t("profile.mobile-phone-no")}
                                                            name="verificationMobileNo"
                                                            defaultValue=""
                                                            autoComplete="off"
                                                            value={this.state.currentMobileNo}
                                                            onChange={this.currentMobileNoFunction}
                                                            minLength={this.state.contactNoMinLimits}
                                                            maxLength={this.state.contactNoMaxLimits}
                                                            minLengthMessage={t("validation.minLength", { 0: this.props.contactNoMinLimits })}
                                                            maxLengthMessage={t("validation.maxLength", { 0: this.props.contactNoMaxLimits })}
                                                            required
                                                            requiredMessage={t("validation.required")}
                                                            errorMsg={this.state.errorMsg.contact_no || ""}
                                                            // formError={this.props.formError}
                                                        />
                                                </div>
                                            </div>
                                            <div>
                                                <small>{t("change-password.enter-code")}</small>
                                                <div className="input-group w-l-border has-validation">
                                                <NumberInput
                                                            className={`form-control forget-pwd-desktop ${this.state.errorMsg.otp_code && "was-validated is-invalid"}`}
                                                            type="number"
                                                            onChange={this.otp_code_Function}
                                                            // onChange={(e) => {
                                                            //   this.setState({
                                                            //     otp_code: e.target.value,
                                                            //   });
                                                            // }}
                                                            placeholder=""
                                                            errorMsg={this.state.errorMsg.otp_code || ""}
                                                            formError={this.state.formError}
                                                            required
                                                            requiredMessage={t("validation.required")}
                                                            value={this.state.otp_code}
                                                            format={
                                                                <span className="input-group-text right-btn-bg ">
                                                                    {this.state.generateOTPStatus && this.state.check_sending_sms_status ? (
                                                                        <button
                                                                            type="button"
                                                                            className={`btn right-btn breg-btn ${this.state.showTime ? "disabled" : "active"}`}
                                                                            onClick={this.resendOTPHandler}
                                                                        >
                                                                            <span>{t("global.resend")}</span>
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            type="button"
                                                                            className={`btn right-btn breg-btn ${this.state.showTime ? "disabled" : "active"}`}
                                                                            onClick={this.generateOTPHandler}
                                                                        >
                                                                            <span>{t("change-password.request-otp")}</span>
                                                                        </button>
                                                                    )}
                                                                </span>
                                                            }
                                                        />
                                                </div>
                            
                                            </div>
                                            <button className="btn btn-gradient-blue rounded-pill" type="submit" disabled={this.props.mobileVarificationCode === "" ? true : false}>
                                                {t("global.submit")}
                                            </button>

                                            <button className="just-blue-btn mt-2 ">
                                                <Link to={{ pathname: "/login" }}>
                                                    {"<<"} {t("global.back")}
                                                </Link>
                                            </button>
                                        </form>
                                    )
                                )}
                            </div>
                        </div>
                    </section>
                )}
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    const { forgotPassword, profile } = state;

    return {
        post_forgot_password_email_data: forgotPassword.post_forgot_password_email_data,
        currentUser: state.currentUser.data,
        generate_sms_otp_result: profile.generate_sms_otp_result,
        verify_sms_otp_result: profile.verify_sms_otp_result,
        resend_otp_result: state.profile.resend_otp_result,
        countryData: state.home.country_data,
        generate_forgot_password_otp_data: forgotPassword.generate_forgot_password_otp_data,
        resend_forgot_password_otp_data: forgotPassword.resend_forgot_password_otp_data,
        verify_forgot_password_otp_data: forgotPassword.verify_forgot_password_otp_data,
        post_forgot_password_data: forgotPassword.post_forgot_password_data,
        check_forgot_password_data: forgotPassword.check_forgot_password_data,
        post_forgot_password_otp_data: forgotPassword.post_forgot_password_otp_data,
    };
};

//Using the redux calling api methods
const mapDispatchToProps = {
    postForgotPasswordEmail,
    generateSMSOTP,
    verifySMSOTP,
    resendOTP,
    getCountry,
    generateForgotPasswordOTP,
    resendForgotPasswordOTP,
    verifyForgotPasswordOTP,
    checkForgotPassword,
    postForgotPassword,
    postForgotPasswordOTP,
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(ForgetPassword));
